// plugins/forgotPasswordModal.js
import Vue from 'vue'
import ForgotPasswordModal from '@/components/forgotPassword'
import router from '@/router'
import i18n from '@/lang'

export default {
  show(options = {}) {
    const Constructor = Vue.extend(ForgotPasswordModal)
    const instance = new Constructor({
      i18n,
      router,
      parent: options.parent || router.app || undefined
    }).$mount()
    document.body.appendChild(instance.$el)
    instance.$on('close', () => {
      // 移除 DOM 并销毁实例
      if (instance.$el && instance.$el.parentNode) {
        instance.$el.parentNode.removeChild(instance.$el)
      }
      instance.$destroy()
      if (typeof options.onClose === 'function') {
        options.onClose()
      }
    })
    instance.$on('backToLogin', () => {
      // 移除 DOM 并销毁实例
      if (instance.$el && instance.$el.parentNode) {
        instance.$el.parentNode.removeChild(instance.$el)
      }
      instance.$destroy()
      if (typeof options.onBackToLogin === 'function') {
        options.onBackToLogin()
      }
    })
  },
}
